Namespace 'Monitoring.Reports.DailyInsights'

class Monitoring.Reports.DailyInsights.HeaderView extends Backbone.View
  className: 'report-header'
  template: JST['backbone/templates/monitoring/reports/daily_insights/header']

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    @$el.html(@template(@options))